/* eslint-disable operator-assignment */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
/* eslint-disable camelcase */
/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
import React, { useState, useCallback } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { Form, Input, Button, Spin, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import { FacebookOutlined, TwitterOutlined } from '@ant-design/icons';
import { Auth0Lock } from 'auth0-lock';
import PulseLoader from 'react-spinners/PulseLoader';
import { AuthWrapper } from './style';
import { login, setAuthToken } from '../../../../redux/authentication/actionCreator';
import { Checkbox } from '../../../../components/checkbox/checkbox';
import Heading from '../../../../components/heading/heading';
import { auth0options } from '../../../../config/auth0';

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const SignIn = () => {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const signIn_URL = 'https://azb2cauth-dev.azurewebsites.net/api/signInUser';
  const dispatch = useDispatch();
  const authToken = useSelector(state => state.auth);
  const [form] = Form.useForm();
  const [state, setState] = useState({
    checked: null,
  });

  const lock = new Auth0Lock(clientId, domain, auth0options);

  const handleSubmit = useCallback(() => {
    dispatch(login());
    // history.push('/');
  }, [history, dispatch]);

  const onChange = checked => {
    setState({ ...state, checked });
  };

  lock.on('authenticated', authResult => {
    lock.getUserInfo(authResult.accessToken, (error, profileResult) => {
      if (error) {
        return;
      }
      handleSubmit();
      lock.hide();
    });
  });

  const logIn = data => {
    dispatch(login());
    setLoading(true);
    if (data.email && data.password) {
      return fetch(signIn_URL, { method: 'POST', cache: 'no-cache', mode: 'cors', body: JSON.stringify(data) })
        .then(response => response.json())
        .then(data => {
          if (!data.error) {
            data.id_token_claims.exp = data.id_token_claims.exp - 5000;
            localStorage.setItem('authToken', JSON.stringify(data));
            dispatch(setAuthToken(data));
            handleSubmit();
            message.success('Login Successfull !');
            setLoading(false);
          } else {
            setLoading(false);
            message.error(`${data.error}`);
            console.log(data);
          }
        })
        .catch(error => message.error('Email or password is incorrect !'));
    }
  };

  return (
    <AuthWrapper>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img src={require('../../../../static/img/Liqural-Logo.png')} style={{ height: '75px' }} />
      </div>
      <div className="auth-contents">
        <Form name="login" form={form} onFinish={logIn} layout="vertical">
          {/* <Heading as="h3">
            Sign in to{' '}
            <span className="color-secondary" style={{ color: '#4285F4' }}>
              Dashboard
            </span>
          </Heading> */}
          <div
            style={{ height: '90px', width: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center' }}
          >
            <Link
              to="/"
              style={{
                display: 'inline-block',
                fontWeight: '500',
                color: '#4285f4',
                fontSize: '13px',
                marginRight: '10px',
                padding: '10px',
                borderBottom: '3px solid #4285f4',
              }}
            >
              SIGN IN
            </Link>
            <Link
              to="/register"
              style={{
                display: 'inline-block',
                fontWeight: '500',
                color: 'black',
                fontSize: '13px',
                marginRight: '10px',
                padding: '10px',
                borderBottom: '3px solid transparent',
              }}
            >
              SIGN UP
            </Link>
          </div>
          <Form.Item name="email" rules={[{ message: 'Please input your Email!', required: true }]} label="">
            <Input placeholder="Email Address" />
          </Form.Item>
          <Form.Item name="password" label="" rules={[{ message: 'Please input your password!', required: true }]}>
            <Input.Password placeholder="Password" />
          </Form.Item>
          <div className="auth-form-action" style={{ marginBottom: '0px' }}>
            {/* <p className="auth-notice">
              Don&rsquo;t have an account? <NavLink to="/register">Sign up now</NavLink>
            </p> */}
          </div>
          <div className="auth-form-action">
            {/* <Checkbox onChange={onChange}>Keep me logged in</Checkbox> */}
            <NavLink className="forgot-pass-link" to="/forgot-password" style={{ marginTop: '-22px' }}>
              Forgot password?
            </NavLink>
          </div>
          <Form.Item>
            <Button className="btn-signin" htmlType="submit" type="primary" size="large">
              {isLoading ? (
                <PulseLoader color="white" loading size={15} aria-label="Loading Spinner" data-testid="loader" />
              ) : (
                'Sign In'
              )}
            </Button>
          </Form.Item>
          {/* <p className="form-divider">
            <span>Or</span>
          </p>
          <ul className="social-login">
            <li>
              <Link className="google-signup" to="#">
                <img src={require('../../../../static/img/google.png')} alt="" />
                <span>Sign in with Google</span>
              </Link>
            </li>
            <li>
              <Link className="facebook-sign" to="#">
                <FacebookOutlined />
              </Link>
            </li>
            <li>
              <Link className="twitter-sign" to="#">
                <TwitterOutlined />
              </Link>
            </li>
          </ul>
          <div className="auth0-login">
            <Link to="#" onClick={() => lock.show()}>
              Sign In with Auth0
            </Link>
            <Link to="/fbSignIn">Sign In With Firebase</Link>
          </div> */}
        </Form>
      </div>
    </AuthWrapper>
  );
};

export default SignIn;
